(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/navbig/assets/javascripts/views/nav-big-statistics-header.js') >= 0) return;  svs.modules.push('/components/statistics/navbig/assets/javascripts/views/nav-big-statistics-header.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.views = svs.statistics.big.views || {};

  svs.statistics.big.views.NavBigStatisticsHeader = Backbone.Marionette.View.extend(
    {
      template: function(data) {
        return svs.statistics.navbig.templates.nav_big_header(data);
      },
      events: {},
      modelEvents: {
        change: 'render'
      },
      ui: {
        backButtonLabel: '.back-button-label'
      },
      log: new svs.core.log.Logger(
        'svs.statistics.big.views.NavBigStatisticsHeader'
      ),
      initialize: function(options) {
        this.app = options.app;
      },
      renderBackButtonLabel: function() {
        var historyList = [];
        if (_.isObject(this.model)) {
          historyList = this.model.get('history');
          if (_.isArray(historyList)) {
            if (historyList.length > 1) {
              this.ui.backButtonLabel.html(
                historyList[historyList.length - 2].label
              );
            }
          }
        }
      },
      onRender: function() {
        this.renderBackButtonLabel();
      },
      onDestroy: function() {
        this.app = null;
        this.stopListening();
      }
    }
  );
})(Backbone, _, svs);

 })(window);